import { useEffect, useState } from "react";
import { useTypeCompaniesContext } from "api/settings/type-companies/TypeCompaniesProvider";
import { FormattedMessage } from "react-intl";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TableManager } from "components/bo/admin-table/TableManager";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { ACTIONS, ENTITIES } from "constants/constants";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import Button from "core/buttons/button/Button";

export default function AdminTypeCompanies({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    typeCompaniesByIdGetter,
    typeCompaniesCreate,
    typeCompaniesDeleteById,
    typeCompaniesList,
    typeCompaniesListGetter,
    typeCompaniesPerId,
    typeCompaniesUpdateById,
  } = useTypeCompaniesContext();

  const typeCompaniesForm = [
    { col: "en", mandatory: true, isMissingValue: null },
    { col: "fr", mandatory: true, isMissingValue: null },
  ];

  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    typeCompaniesListGetter();
  }, [typeCompaniesListGetter]);

  useEffect(() => {
    if (id) {
      typeCompaniesByIdGetter(id);
    }
  }, [id]);

  const handleDelete = async (typeCompaniesId) =>
    setDeleteData(typeCompaniesList.find((e) => e.id === typeCompaniesId));

  const validateDelete = async (typeCompaniesId) => {
    try {
      await typeCompaniesDeleteById(typeCompaniesId);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCreate = (payload) => {
    try {
      typeCompaniesCreate(payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  const handleEdit = (payload) => {
    try {
      typeCompaniesUpdateById(payload.id, payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };

  // Todo gestion droits admin
  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.TYPE_COMPANIES}
        entityPerId={typeCompaniesPerId}
        list={typeCompaniesList}
        inputs={typeCompaniesForm}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />

      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={validateDelete}
          deleteData={deleteData}
          entity={ENTITIES.TYPE_COMPANIES}
        />
      </div>
    </div>
  );
}
